import React from 'react';
import { TextField, TextFieldProps } from 'mui-rff';
import cc from 'classnames';

import { showErrorOnChange } from 'utils/validation';

import styles from './Input.module.css';

type Props = {
  optional?: boolean;
};

const Input = ({
  type = 'text',
  variant = 'filled',
  InputProps,
  className,
  optional,
  ...props
}: TextFieldProps & Props) => (
  <div className={cc(className, styles.container)}>
    <TextField
      type={type}
      variant={variant}
      InputProps={
        variant !== 'outlined'
          ? {
            ...InputProps,
            disableUnderline: true,
          }
          : InputProps
      }
      showError={showErrorOnChange}
      className={cc(
        // eslint-disable-next-line css-modules/no-undef-class
        styles.input,
        // eslint-disable-next-line css-modules/no-undef-class
        { [styles.text]: type === 'text' || type === 'tel' },
      )}
      {...props}
    />
    {optional && <span className={styles.optional}>Optional</span>}
  </div>
);

export default Input;
